import React, { useId } from 'react';

import { InputControl } from '../components/InputControl';
import { InputField } from '../components/InputField';
import { InputFieldBody } from '../components/InputFieldBody';
import { Text } from '../../Text';
import { CommonInputProps, RawInputProps } from '../types';
import { Box } from '../../Box';

type Props = {
  prefixText?: string;
  suffixText?: string;
} & CommonInputProps &
  RawInputProps;

export const RawInputNumber = (props: Props) => {
  const id = useId();
  const {
    name,
    placeholder,
    error,
    disabled,
    helpText,
    label,
    prefixText,
    validations = {},
    condensed,
    value,
    onChange,
  } = props;

  return (
    <InputControl
      error={error}
      helpText={helpText}
      label={label}
      htmlFor={id}
      condensed={condensed}
    >
      <InputField hasError={Boolean(error)} disabled={disabled}>
        {prefixText && (
          <Box alignSelf="center">
            <Text color="grey-dark" mr={2}>
              {prefixText}
            </Text>
          </Box>
        )}
        <InputFieldBody
          disabled={disabled}
          placeholder={placeholder}
          id={id}
          name={name}
          validations={validations}
          value={value}
          onChange={onChange}
          type="number"
        />
      </InputField>
    </InputControl>
  );
};
